import React from "react";
import { ClipboardList, Network, Sparkles } from "lucide-react";
import { SidebarLayout } from "@/components/SidebarLayout";
import { useAuth } from "@/context/AuthContext";

const NAV = [
  { to: "/", label: "Sorties", icon: ClipboardList, testid: "nav-sorties", end: true },
  { to: "/demandes", label: "Demande transport (IA)", icon: Sparkles, testid: "nav-demandes" },
  { to: "/tribu", label: "Ma Tribu", icon: Network, testid: "nav-tribu" },
];

export function EtabLayout({ children }) {
  const { user } = useAuth();
  return (
    <SidebarLayout nav={NAV} title={user?.etablissement_name} subtitle={user?.email}>
      {children}
    </SidebarLayout>
  );
}
